import script from "./EditMetadataModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditMetadataModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditMetadataModal.vue?vue&type=style&index=0&id=0f3d1c30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f3d1c30"]])

export default __exports__